import { type SystemStyleObject, defineStyleConfig } from '@chakra-ui/system';

const container = {};

const track: SystemStyleObject = {
    padding: 0,
    width: '37px',
    height: '17px',
    border: '1px solid',
    borderColor: 'black',
    background: 'white',
    _checked: {
        background: 'black',
    },
    _focus: {
        boxShadow: 'unset',
        outlineStyle: 'solid',
        outlineColor: 'slt-black.900',
        outlineOffset: '1px',
        outlineWidth: '1px',
    },
};

const thumb: SystemStyleObject = {
    height: '17px',
    outline: '1px solid',
    outlineColor: 'black',
    _checked: {
        transform: 'translateX(21px)',
    },
};

export const Switch = defineStyleConfig({
    variants: {
        slt: {
            container,
            track,
            thumb,
        },
        'new-toggle': {
            _focus: {
                outline: 'none',
                boxShadow: 'none',
            },
            _focusVisible: {
                outline: 'none',
                boxShadow: 'none',
            },
            container: {
                display: 'inline-block',
            },
            track: {
                outline: 'solid',
                outlineWidth: '1px',
                outlineOffset: '-1px',
                outlineColor: 'slt-pepper.1000',
                width: '32px',
                height: '16px',
                backgroundColor: 'slt-pepper.100',
                borderRadius: '100px',
                boxSizing: 'border-box',
                padding: 0,
                _checked: {
                    backgroundColor: 'slt-primary-green.1000',
                    outlineColor: 'slt-primary-green.1000',
                },
            },
            thumb: {
                outline: 'solid',
                outlineWidth: '1px',
                outlineOffset: '-1px',
                outlineColor: 'slt-pepper.1000',
                width: '16px',
                height: '16px',
                backgroundColor: 'white',
                boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.15)',
                transform: 'translateX(0)',
                boxSizing: 'border-box',
                _checked: {
                    transform: 'translateX(16px)',
                    outlineColor: 'slt-primary-green.1000',
                },
            },
        },
    },
    defaultProps: {
        variant: 'slt',
    },
});
